import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import {
	WMS1120_R01SalesDto,
	WMS1120_R01SalesLotDto,
	WMS1120_R01ProductBaseDto,
	WMS1120_R01ProductLotDto,
	WMS1120_R01ProductResultDto,
	WMS1120_R01BomDto,
	WMS1120_R01StockDto,
	WMS1120_R01SalesFilter,
	WMS1120_R01ProductBaseFilter,
	WMS1120_R01ProductResultFilter,
	WMS1120_R01StockFilter,
} from './Dto_WMS1120_R01';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';

export type WMS1120_R01_TabType = 'sales' | 'product';

export type WMS1120ScrollTopKey =
	| 'sales'
	| 'salesLot'
	| 'product'
	| 'productLot'
	| 'productResult'
	| 'bom'
	| 'stock';

export interface WMS1120ScrollTop {
	sales: number | null;
	salesLot: number | null;
	product: number | null;
	productLot: number | null;
	productResult: number | null;
	bom: number | null;
	stock: number | null;
}

const defaultWMS1120ScrollTop = (): WMS1120ScrollTop => ({
	sales: null,
	salesLot: null,
	product: null,
	productLot: null,
	productResult: null,
	bom: null,
	stock: null,
});

export interface WMS1120_R01Filter {
	// 매출기준 필터
	salesDateRange: DateRange | undefined;
	salesCompCdCondition: string;
	salesCustomCdCondition: string;
	salesItemCd: string;
	
	// 생산기준 필터
	productDateRange: DateRange | undefined;
	productCompCdCondition: string;
	productItemCdCondition: string;
	productWorkProcessCondition: string;
}

export interface Store_WMS1120_R01 {
	// 탭 상태
	WMS1120_R01activeTab: WMS1120_R01_TabType;
	setWMS1120_R01ActiveTab: (tab: WMS1120_R01_TabType) => void;
	
	// 필터
	WMS1120_R01Filter: WMS1120_R01Filter;
	setWMS1120_R01Filter: (filter: Partial<WMS1120_R01Filter>) => void;
	
	// 매출기준 데이터
	WMS1120_R01dataList: WMS1120_R01SalesDto[];
	setWMS1120_R01SalesList: (list: WMS1120_R01SalesDto[]) => void;
	selectedWMS1120_R01Sales: WMS1120_R01SalesDto | undefined;
	setSelectedWMS1120_R01Sales: (data: WMS1120_R01SalesDto | undefined) => void;
	WMS1120_R01salesLotList: WMS1120_R01SalesLotDto[];
	setWMS1120_R01SalesLotList: (list: WMS1120_R01SalesLotDto[]) => void;
	selectedWMS1120_R01SalesLot: WMS1120_R01SalesLotDto | undefined;
	setSelectedWMS1120_R01SalesLot: (data: WMS1120_R01SalesLotDto | undefined) => void;
	WMS1120_R01salesAllCount: number;
	setWMS1120_R01SalesAllCount: (count: number) => void;
	
	// 생산기준 데이터
	WMS1120_R01productBaseList: WMS1120_R01ProductBaseDto[];
	setWMS1120_R01ProductBaseList: (list: WMS1120_R01ProductBaseDto[]) => void;
	selectedWMS1120_R01ProductBase: WMS1120_R01ProductBaseDto | undefined;
	setSelectedWMS1120_R01ProductBase: (data: WMS1120_R01ProductBaseDto | undefined) => void;
	WMS1120_R01productLotList: WMS1120_R01ProductLotDto[];
	setWMS1120_R01ProductLotList: (list: WMS1120_R01ProductLotDto[]) => void;
	selectedWMS1120_R01ProductLot: WMS1120_R01ProductLotDto | undefined;
	setSelectedWMS1120_R01ProductLot: (data: WMS1120_R01ProductLotDto | undefined) => void;
	
	// 하단 테이블 데이터
	WMS1120_R01productResultList: WMS1120_R01ProductResultDto[];
	setWMS1120_R01ProductResultList: (list: WMS1120_R01ProductResultDto[]) => void;
	selectedWMS1120_R01ProductResult: WMS1120_R01ProductResultDto | undefined;
	setSelectedWMS1120_R01ProductResult: (data: WMS1120_R01ProductResultDto | undefined) => void;
	WMS1120_R01bomList: WMS1120_R01BomDto[];
	setWMS1120_R01BomList: (list: WMS1120_R01BomDto[]) => void;
	selectedWMS1120_R01Bom: WMS1120_R01BomDto | undefined;
	setSelectedWMS1120_R01Bom: (data: WMS1120_R01BomDto | undefined) => void;
	WMS1120_R01stockList: WMS1120_R01StockDto[];
	setWMS1120_R01StockList: (list: WMS1120_R01StockDto[]) => void;
	selectedWMS1120_R01Stock: WMS1120_R01StockDto | undefined;
	setSelectedWMS1120_R01Stock: (data: WMS1120_R01StockDto | undefined) => void;
	
	// 컬럼 상태
	WMS1120_R01salesColumnState: ColumnState[] | null;
	setWMS1120_R01SalesColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01salesLotColumnState: ColumnState[] | null;
	setWMS1120_R01SalesLotColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01productBaseColumnState: ColumnState[] | null;
	setWMS1120_R01ProductBaseColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01productLotColumnState: ColumnState[] | null;
	setWMS1120_R01ProductLotColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01productResultColumnState: ColumnState[] | null;
	setWMS1120_R01ProductResultColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01bomColumnState: ColumnState[] | null;
	setWMS1120_R01BomColumnState: (state: ColumnState[] | null) => void;
	WMS1120_R01stockColumnState: ColumnState[] | null;
	setWMS1120_R01StockColumnState: (state: ColumnState[] | null) => void;

	WMS1120ScrollTop: WMS1120ScrollTop;
	setWMS1120ScrollTop: (key: WMS1120ScrollTopKey, top: number | null) => void;
	resetWMS1120ScrollTop: (keys: WMS1120ScrollTopKey[]) => void;
	resetAllWMS1120ScrollTop: () => void;
	
	// 초기화
	initData: () => void;
}

export const defaultWMS1120_R01Filter: WMS1120_R01Filter = {
	salesDateRange: {
		from: new Date(new Date().getFullYear(), 0, 1),
		to: new Date(new Date().getFullYear(), 11, 30),
	},
	salesCompCdCondition: '',
	salesCustomCdCondition: '',
	salesItemCd: '',
	productDateRange: {
		from: new Date(new Date().getFullYear(), 0, 1),
		to: new Date(new Date().getFullYear(), 11, 30),
	},
	productCompCdCondition: '',
	productItemCdCondition: '',
	productWorkProcessCondition: '',
};

export const useWMS1120_R01Store = create<Store_WMS1120_R01>((set) => ({
	// 탭 상태
	WMS1120_R01activeTab: 'sales',
	setWMS1120_R01ActiveTab: (tab: WMS1120_R01_TabType) => set({ 
		WMS1120_R01activeTab: tab,
		// 탭 변경 시 하단 테이블 선택 상태 자동 초기화
		selectedWMS1120_R01ProductResult: undefined,
		selectedWMS1120_R01Bom: undefined,
		selectedWMS1120_R01Stock: undefined,
	}),
	
	// 필터
	WMS1120_R01Filter: defaultWMS1120_R01Filter,
	setWMS1120_R01Filter: (update) => set((state) => ({
		WMS1120_R01Filter: {
			...state.WMS1120_R01Filter,
			...update,
		},
	})),
	
	// 매출기준 데이터
	WMS1120_R01dataList: [],
	setWMS1120_R01SalesList: (list) => set((state) => {
		let newList: WMS1120_R01SalesDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01dataList: newList };
	}),
	selectedWMS1120_R01Sales: undefined,
	setSelectedWMS1120_R01Sales: (data) => set({ selectedWMS1120_R01Sales: data }),
	WMS1120_R01salesLotList: [],
	setWMS1120_R01SalesLotList: (list) => set((state) => {
		let newList: WMS1120_R01SalesLotDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01salesLotList: newList };
	}),
	selectedWMS1120_R01SalesLot: undefined,
	setSelectedWMS1120_R01SalesLot: (data) => set({ selectedWMS1120_R01SalesLot: data }),
	WMS1120_R01salesAllCount: 0,
	setWMS1120_R01SalesAllCount: (count) => set({ WMS1120_R01salesAllCount: count }),
	
	// 생산기준 데이터
	WMS1120_R01productBaseList: [],
	setWMS1120_R01ProductBaseList: (list) => set((state) => {
		let newList: WMS1120_R01ProductBaseDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01productBaseList: newList };
	}),
	selectedWMS1120_R01ProductBase: undefined,
	setSelectedWMS1120_R01ProductBase: (data) => set({ selectedWMS1120_R01ProductBase: data }),
	WMS1120_R01productLotList: [],
	setWMS1120_R01ProductLotList: (list) => set((state) => {
		let newList: WMS1120_R01ProductLotDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01productLotList: newList };
	}),
	selectedWMS1120_R01ProductLot: undefined,
	setSelectedWMS1120_R01ProductLot: (data) => set({ selectedWMS1120_R01ProductLot: data }),
	
	// 하단 테이블 데이터
	WMS1120_R01productResultList: [],
	setWMS1120_R01ProductResultList: (list) => set({ WMS1120_R01productResultList: list }),
	selectedWMS1120_R01ProductResult: undefined,
	setSelectedWMS1120_R01ProductResult: (data) => set({ selectedWMS1120_R01ProductResult: data }),
	WMS1120_R01bomList: [],
	setWMS1120_R01BomList: (list) => set((state) => {
		let newList: WMS1120_R01BomDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01bomList: newList };
	}),
	selectedWMS1120_R01Bom: undefined,
	setSelectedWMS1120_R01Bom: (data) => set({ selectedWMS1120_R01Bom: data }),
	WMS1120_R01stockList: [],
	setWMS1120_R01StockList: (list) => set((state) => {
		let newList: WMS1120_R01StockDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { WMS1120_R01stockList: newList };
	}),
	selectedWMS1120_R01Stock: undefined,
	setSelectedWMS1120_R01Stock: (data) => set({ selectedWMS1120_R01Stock: data }),
	
	// 컬럼 상태
	WMS1120_R01salesColumnState: null,
	setWMS1120_R01SalesColumnState: (state) => set({ WMS1120_R01salesColumnState: state }),
	WMS1120_R01salesLotColumnState: null,
	setWMS1120_R01SalesLotColumnState: (state) => set({ WMS1120_R01salesLotColumnState: state }),
	WMS1120_R01productBaseColumnState: null,
	setWMS1120_R01ProductBaseColumnState: (state) => set({ WMS1120_R01productBaseColumnState: state }),
	WMS1120_R01productLotColumnState: null,
	setWMS1120_R01ProductLotColumnState: (state) => set({ WMS1120_R01productLotColumnState: state }),
	WMS1120_R01productResultColumnState: null,
	setWMS1120_R01ProductResultColumnState: (state) => set({ WMS1120_R01productResultColumnState: state }),
	WMS1120_R01bomColumnState: null,
	setWMS1120_R01BomColumnState: (state) => set({ WMS1120_R01bomColumnState: state }),
	WMS1120_R01stockColumnState: null,
	setWMS1120_R01StockColumnState: (state) => set({ WMS1120_R01stockColumnState: state }),

	WMS1120ScrollTop: defaultWMS1120ScrollTop(),
	setWMS1120ScrollTop: (key, top) => set((state) => ({
		WMS1120ScrollTop: {
			...state.WMS1120ScrollTop,
			[key]: top,
		},
	})),
	resetWMS1120ScrollTop: (keys) => set((state) => {
		const next = { ...state.WMS1120ScrollTop };
		keys.forEach((key) => { next[key] = null; });
		return { WMS1120ScrollTop: next };
	}),
	resetAllWMS1120ScrollTop: () => set({ WMS1120ScrollTop: defaultWMS1120ScrollTop() }),
	
	// 초기화
	initData: () => set({
		WMS1120_R01Filter: defaultWMS1120_R01Filter,
		WMS1120_R01dataList: [],
		selectedWMS1120_R01Sales: undefined,
		WMS1120_R01salesLotList: [],
		selectedWMS1120_R01SalesLot: undefined,
		WMS1120_R01salesAllCount: 0,
		WMS1120_R01productBaseList: [],
		selectedWMS1120_R01ProductBase: undefined,
		WMS1120_R01productLotList: [],
		selectedWMS1120_R01ProductLot: undefined,
		WMS1120_R01productResultList: [],
		selectedWMS1120_R01ProductResult: undefined,
		WMS1120_R01bomList: [],
		selectedWMS1120_R01Bom: undefined,
		WMS1120_R01stockList: [],
		selectedWMS1120_R01Stock: undefined,
		WMS1120ScrollTop: defaultWMS1120ScrollTop(),
	}),
}));

